export const purple = "#91278F";
export const background = "#FEFAFE";
export const purpleLightActive = "#DFB0DF";
export const orangeLightActive = "#FAEDEA";
export const purpleLight = "#F5E6F5";
export const purpleLightHover = "#F0D9F0";
export const greyEnabled = "#7C797C";
export const orange = "#D14C2E";
// Primary text/heading color used across the app — labels, titles, values.
export const black = "#1B001B";

// Extended accent palette — same soft-tint + solid-accent pairing as the
// tokens above, used to tell categories/cards apart (e.g. report types).
export const blue = "#2456A6";
export const blueLight = "#E7EEF9";
export const green = "#1F8A4C";
export const greenLight = "#E7F5EC";
export const teal = "#0F7A6E";
export const tealLight = "#E3F3F1";
export const indigo = "#39469C";
export const indigoLight = "#E9EBF7";
export const amber = "#B7791F";
export const amberLight = "#FBF0DE";
export const red = "#C62828";
export const redLight = "#FDECEA";